var _mask, _g, _mask2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "y4zcel31va",
    width: 50,
    height: 35,
    x: 0,
    y: 3,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 3h50v34.201H0V3z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#y4zcel31va)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M14.658 27.43c-.9 0-1.629.729-1.629 1.628v4.886H3.257v-4.886c0-6.286 5.114-11.4 11.401-11.4h4.397v9.772h-4.397zm33.713-7.452c.9 0 1.63-.73 1.63-1.629v-1.506c0-.113-.012-.222-.034-.328-.163-1.192-1.175-2.115-2.41-2.115h-4.96c-.389-2.306-2.396-4.071-4.812-4.071h-5.293V6.257h6.107c.9 0 1.629-.729 1.629-1.628 0-.9-.73-1.629-1.629-1.629H23.127c-.9 0-1.629.73-1.629 1.629 0 .9.73 1.628 1.629 1.628h6.108v4.072H23.94c-2.416 0-4.422 1.764-4.812 4.071h-4.47C6.574 14.4 0 20.976 0 29.058v6.514c0 .9.73 1.629 1.629 1.629h13.03c.899 0 1.628-.73 1.628-1.629v-4.885h3.053c.673 1.894 2.479 3.257 4.601 3.257h5.194c.9 0 1.63-.729 1.63-1.628 0-.9-.73-1.629-1.63-1.629H23.94c-.898 0-1.628-.73-1.628-1.629V15.214c0-.898.73-1.629 1.628-1.629h13.844c.899 0 1.629.731 1.629 1.629v13.844c0 .898-.73 1.63-1.629 1.63-.9 0-1.628.728-1.628 1.628 0 .9.729 1.628 1.628 1.628 1.804 0 3.379-.985 4.225-2.443h5.547c1.347 0 2.443-1.096 2.443-2.443v-4.672c0-.9-.73-1.628-1.629-1.628s-1.628.729-1.628 1.628v3.858H42.67V17.657h4.072v.692c0 .9.73 1.63 1.628 1.63z",
    clipRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "dt3x7iyy0b",
    width: 4,
    height: 8,
    x: 6,
    y: 39,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.025 39.645h3.258v7.329H6.025v-7.33z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dt3x7iyy0b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M7.654 39.645c-.9 0-1.629.729-1.629 1.628v4.072c0 .9.73 1.63 1.63 1.63.898 0 1.628-.73 1.628-1.63v-4.072c0-.9-.73-1.629-1.629-1.629",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.c014d858dc64cf4b5a512cece5970304.svg";
export { ForwardRef as ReactComponent };